export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Rafay. I'm a Flutter Mobile App Developer",
  description2:
    "An Undergraduate CSIT Student at NEDUET having expertise in Mobile Application Development using Flutter & Dart, currently working as a freelancer and exploring different frameworks. I have keen interest in teaching students the Mobile App Development Code",
  image: 1,
};
